var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZoomOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.794,
    height: 26.793,
    viewBox: "0 0 26.794 26.793",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_309",
    "data-name": "Group 309",
    transform: "translate(-257.206 -1204.055)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M23.327,23.326a1.675,1.675,0,0,1,2.37,0l6.447,6.447a1.675,1.675,0,1,1-2.367,2.37L23.329,25.7a1.675,1.675,0,0,1,0-2.37Z",
    transform: "translate(251.365 1198.215)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M10.885,20.095a9.21,9.21,0,1,0-9.21-9.21A9.21,9.21,0,0,0,10.885,20.095Zm10.885-9.21A10.885,10.885,0,1,1,10.885,0,10.885,10.885,0,0,1,21.769,10.885Z",
    transform: "translate(257.206 1204.055)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_72",
    "data-name": "Line 72",
    x2: 9,
    transform: "translate(263.591 1215.334)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomOut);
export default __webpack_public_path__ + "static/media/zoom_out.d45e3e13f2add9847a164dba185bab91.svg";
export { ForwardRef as ReactComponent };